import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ColliContent, ColliContentListResponse, ColliContentQueryParams, CreateColliContent, UpdateColliContent } from '@frontend/colli/types';

export class ColliContentClient extends APIClient {
    public static readonly endpoint = '/colli-api/v1';

    public static async fetchColliContents(queryParams?: ApiQueryParams<ColliContentQueryParams>): Promise<ColliContentListResponse> {
        return await this.apiPaginated<ColliContentListResponse, ColliContentQueryParams>(`${this.endpoint}/contents`, queryParams);
    }

    public static async resolveColliContents(ids: string[]): Promise<ColliContentListResponse> {
        const response = await this.post(`${this.endpoint}/contents-resolve`, { ids: ids });
        return await this.handleResponse<ColliContentListResponse>(response);
    }

    public static async deleteColliContents(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/contents-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postColliContent(accountId: string, transactionId: string, colliId: string, body: CreateColliContent): Promise<ColliContent> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/contents`, body);
        return await this.handleResponse<ColliContent>(response);
    }

    public static async fetchAccountTransactionColliContent(
        accountId: string,
        transactionId: string,
        colliId: string,
        colliContentId: string
    ): Promise<ColliContent> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/contents/${colliContentId}`);
        return await this.handleResponse<ColliContent>(response);
    }

    public static async patchColliContent(
        accountId: string,
        transactionId: string,
        colliId: string,
        colliContentId: string,
        body: UpdateColliContent
    ): Promise<ColliContent> {
        const response = await this.patch(
            `${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/contents/${colliContentId}`,
            body
        );
        return await this.handleResponse<ColliContent>(response);
    }

    public static async deleteColliContent(accountId: string, transactionId: string, colliId: string, colliContentId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/contents/${colliContentId}`);
        return await this.handleVoidResponse(response);
    }
}
